import { fetchSortedSavedSearches, SavedSearch } from '@creditsights/api-ui-web';
import { uniq } from 'lodash';
import { useQuery, UseQueryResult } from 'react-query';
import { searchTags } from '../../services/tags/tags.service';
import { queryKeys } from '../queryKeyFactory';
import { mapSavedSearchesDtoToModel } from './utils/savedSearches.mappers';

export default (): UseQueryResult<SavedSearch[], Error> => {
  return useQuery<SavedSearch[], Error>([queryKeys.fetchSavedSearches.all], async () => {
    const sortedSavedSearches = await fetchSortedSavedSearches();

    const savedSearchTags = sortedSavedSearches
      .map((savedSearch) => savedSearch.filters?.map((filter) => filter.tags) || [])
      .flat(2);
    // fetch tags with uniq tagIds from saved search filters
    const tags = savedSearchTags.length > 0 ? await searchTags(uniq(savedSearchTags)) : {};

    return mapSavedSearchesDtoToModel(sortedSavedSearches, tags);
  });
};
